/** Brand slogan — always shown in English across locales. */
export const COLOZOO_SLOGAN = 'Creating happiness!'
